import React, { forwardRef } from 'react'
import DayFilteringWidget from '../student/DayFilteringWidget'
import CheckInWidget from '../student/CheckInWidget'
import StudentWellbeingComparisonWidget from '../student/StudentWellbeingComparisonWidget'
import DetailsOnEmotions from '../student/DetailsOnEmotions'
import ReasonsForEmotionsWidget from '../student/ReasonsForEmotionsWidget'
import AlertsWidget from '../student/AlertsWidget'
import AssignedActionWidget from '../student/AssignedActionWidget'
import ParticipationWidget from '../student/ParticipationWidget'
import ClassEmotionalWellbeing from './ClassEmotionalWellbeing'
import AnalyticsWidgetEvents from '../../../analytics/AnalyticsWidgetEvents'

export const daysFilterList = [
    { label: '7 Days', numberOfDays: 7, code: 'week' },
    { label: '1 Month', numberOfDays: 30, code: 'month' },
    { label: '3 Months', numberOfDays: 91, code: '3months' },
    { label: '1 Year', numberOfDays: 365, code: 'year' },
    { label: 'Custom', numberOfDays: 365, code: 'custom' },
]

const ClassAnalyticsWidgets = forwardRef(({ selectedClass, subjectId, daysFilter, setDaysFilter }, ref) => {
    const isPrimaryClass = !!selectedClass.primary

    return (
        <div ref={ref} className="flex-1 overflow-x-hidden px-2 pt-[20px] pb-5 overflow-y-auto">
            <AnalyticsWidgetEvents
                subjectId={subjectId || selectedClass?.id}
                widgets={[
                    { key: 'check-in', label: 'Check-in' },
                    { key: 'wellbeing-comparison', label: 'Wellbeing comparison' },
                    { key: 'emotion-details', label: 'Emotion details' },
                    ...(!isPrimaryClass ? [{ key: 'emotion-reasons', label: 'Reasons for emotions' }] : []),
                    { key: 'class-emotional-wellbeing', label: 'Class emotional wellbeing' },
                    { key: 'alerts', label: 'Alerts' },
                    { key: 'assigned-actions', label: 'Assigned actions' },
                    ...(!isPrimaryClass ? [{ key: 'participation', label: 'Participation' }] : []),
                ]}
            />
            <DayFilteringWidget daysFilter={daysFilter} daysFilterList={daysFilterList} setDaysFilter={setDaysFilter} />
            <div className="w-full h-[1px] bg-white mt-4"></div>

            <CheckInWidget daysFilter={daysFilter} analyticsType="class" />
            <StudentWellbeingComparisonWidget daysFilter={daysFilter} selectedClass={selectedClass} isStudentAnalytics={false} />
            <DetailsOnEmotions daysFilter={daysFilter} />
            {!isPrimaryClass && <ReasonsForEmotionsWidget daysFilter={daysFilter} />}
            <ClassEmotionalWellbeing daysFilter={daysFilter} isPrimaryClass={isPrimaryClass} />
            <AlertsWidget daysFilter={daysFilter} />
            <AssignedActionWidget daysFilter={daysFilter} />
            {!isPrimaryClass && <ParticipationWidget daysFilter={daysFilter} selectedClass={selectedClass} />}
            {/* <AttentionWidget student={student} daysFilter={daysFilter} /> */}
        </div>
    )
})

export default ClassAnalyticsWidgets
